export enum UnitPaymentCategory {
  None = 0,
  Maintenance = 1,
  Management = 2,
  Utilities = 3,
  LegalFees = 4,
  Other = 5
}

// tslint:disable-next-line:no-namespace
export namespace UnitPaymentCategory {
  export function toString(crePaymentCategory: UnitPaymentCategory): string {
    switch (crePaymentCategory) {
      case UnitPaymentCategory.None:
        return 'None';
      case UnitPaymentCategory.Maintenance:
        return 'Maintenance';
      case UnitPaymentCategory.Management:
        return 'Management';
      case UnitPaymentCategory.Utilities:
        return 'Utilities';
      case UnitPaymentCategory.LegalFees:
        return 'Legal Fees';
      case UnitPaymentCategory.Other:
        return 'Other';
    }
  }

  export function listAll() {
    return [UnitPaymentCategory.Maintenance, UnitPaymentCategory.Management, UnitPaymentCategory.Utilities,
            UnitPaymentCategory.LegalFees, UnitPaymentCategory.Other];
  }
}
